import BaseService from "@/services/BaseService";

class EstadosService extends BaseService {
  constructor() {
    super("/v1/estados");
  }
}

export default new EstadosService();
